import APIService from "@/services/APIService.js";

const apiProfissoes = APIService.create({
  baseURL: process.env.VUE_APP_API_URL + "/admin/profissao"
});

export default {
  getAll(limit, page, filters) {
    return apiProfissoes.get("", {
      params: {
        limit: limit,
        offset: page * limit - limit,
        sort_by: "nome",
        ...filters
      }
    });
  },
  update(id, profissao) {
    return apiProfissoes.put("/" + id, profissao);
  },
  create(profissao) {
    return apiProfissoes.post("", profissao);
  }
};
